import React from "react";
import NavBar from "../../Components/NavBar";
import AfCareSections from "../../Components/AfCare/AfCareSections";

const AfCare = () => {
  return (
    <div className="">
      <NavBar onlyWhiteBg="true" />

      <AfCareSections />
    </div>
  );
};

export default AfCare;
